<template>
	<v-container fluid pa-0 dark flat>
		<div class="overlay-loading" v-if="loadingPedido">
    		<LoadingLogo/>
    		<h3>Estamos procesando tu solicitud.</h3>
	 	</div>
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex xs12 justify-center>
				<h1>Pedido</h1>
				<h3 class="text-duo font-weight-regular mb-2">Comunícate con nosotros si tienes alguna duda o necesitas de nuestros servicios.</h3>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="inner-container" justify-center mx-5 mb-5 mt-4>
			<v-flex xs12 md6>
				<h2 class="mb-4 text-duo font-weight-regular">Envíanos un mensaje</h2>
				<v-container>
					<v-form ref="contactForm">
						<v-layout row wrap>
							<v-flex xs12 md6 px-2>
								<v-text-field
									v-model="datos.personales.nombre"
									:rules="rules.required"
									label="Nombre"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs12 md6 px-2>
								<v-text-field
									v-model="datos.personales.apellido"
									:rules="rules.required"
									label="Apellido"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs12 md6 px-2>
								<v-text-field
									v-model="datos.personales.email"
									:rules="rules.emailRules"
									label="Email"
									required
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout>
							<v-flex xs12 md4 px-2>
								<v-select
									v-model="codigoDefault"
									:items="codigos"
									:rules="rules.nameRules"
									append-icon="fas fa-caret-down"
									label="Código País"
								></v-select>
							</v-flex>
							<v-flex xs12 md8 px-2>
								<v-text-field
									v-model="datos.personales.telefono"
									:rules="rules.required"
									counter="9"
									maxlength="9"
									label="Teléfono"
									required
								></v-text-field>
							</v-flex>
						</v-layout>
					<!-- Insertar mapa origen de google -->
					<!-- <v-layout row wrap> -->
						<v-layout>
					<v-flex  :class="{'pa-0': $vuetify.breakpoint.smAndDown, 'pl-0': $vuetify.breakpoint.mdAndUp}"> <!-- empieza acá -->
						<!-- <v-layout ma-3> -->
							<!-- <v-flex md12 sm12 xs12 mx-3> -->
							<v-flex md12 sm12 xs12 mx-2>	
								<v-text-field
									label="DIRECCIÓN DE ORIGEN, Ingresa calle, número y luego selecciona la sugerencia"
									v-model="datos.direccion_origen.direccion"
									id="starting_address"
									:rules="rules.direccionOrigen"
									placeholder="DIRECCIÓN DE ORIGEN"
									v-on:change="datos.direccion_origen.marker = {}"
									required>
								</v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 1"
									v-model="datos.paradas[0].direccion"
									id="location_address"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[0].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 2"
									v-model="datos.paradas[1].direccion"
									id="location_address_2"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[1].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 3"
									v-model="datos.paradas[2].direccion"
									id="location_address_3"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[2].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 4"
									v-model="datos.paradas[3].direccion"
									id="location_address_4"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[3].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 5"
									v-model="datos.paradas[4].direccion"
									id="location_address_5"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[4].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 6"
									v-model="datos.paradas[5].direccion"
									id="location_address_6"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[5].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 7"
									v-model="datos.paradas[6].direccion"
									id="location_address_7"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[6].marker = {}"
								></v-text-field>
								<v-text-field
									label="Añadir Parada"
									v-show="stops >= 8"
									v-model="datos.paradas[7].direccion"
									id="location_address_8"
									placeholder="Añadir Parada"
									v-on:change="datos.paradas[7].marker = {}"
								></v-text-field>
								<v-text-field
									label="DESTINO FINAL, Ingrese calle, número y luego selecciona la sugerencia"
									v-model="datos.direccion_destino.direccion"
									id="destination_address"
									:rules="rules.direccionDestino"
									placeholder="DIRECCIÓN DE DESTINO FINAL"
									v-on:change="datos.direccion_destino.marker = {}"
									required
								></v-text-field>
								<v-btn color="#1f97b9" dark mini @click="addStop">Añadir Parada</v-btn>
								<v-btn v-if="stops >= 1" color="#FF2D00" dark mini @click="eraseStop">Eliminar Parada</v-btn>
								<p></p>
								<input v-if="stops >= 2" type="checkbox" id="optimized Route" v-model="checked" @change="changeOptimization"><label v-if="stops >= 2"> Optimizar Ruta</label>
								<p v-if="showDistance"><b>Distancia recorrido: </b>{{ distanciaMetrica }} KM</p>
								<p></p>
								<GmapMap
									ref="mapDirections"
									:center="Object.keys(this.datos.direccion_destino.marker).length > 0 ? this.datos.direccion_destino.marker : {lat: -33.437637, lng: -70.650471}"
									:zoom="15"
									style="width: 100%; height: 300px"
								>
									<GmapMarker
										v-if="Object.keys(this.datos.direccion_destino.marker).length > 0"
										:position="datos.direccion_destino.marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[0].marker).length > 0"
										:position="datos.paradas[0].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[1].marker).length > 0"
										:position="datos.paradas[1].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[2].marker).length > 0"
										:position="datos.paradas[2].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[3].marker).length > 0"
										:position="datos.paradas[3].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[4].marker).length > 0"
										:position="datos.paradas[4].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[6].marker).length > 0"
										:position="datos.paradas[6].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[7].marker).length > 0"
										:position="datos.paradas[7].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.paradas[0].marker).length > 0"
										:position="datos.paradas[0].marker" 
										/>
									/>
									<GmapMarker
										v-if="Object.keys(this.datos.direccion_origen.marker).length > 0"
										:position="datos.direccion_origen.marker" 
										/>
									/>
									<gmap-polyline
										:options="{'strokeColor': '#1f97b9'}"
										:path="theLatLngs" 
										:editable="false" 
										ref="polygon">
									</gmap-polyline>
								</GmapMap>
								</v-flex>
							<!-- </v-layout> -->
						</v-flex><!-- Fin de mapas -->
					</v-layout>
				</v-form>
			</v-container>
		</v-flex>
		
		<!-- mensaje -->
		<v-flex xs12 md6>
			<v-layout>
				<v-flex xs12 md12 px-2>
					<v-textarea
						name="input-7-1"
						label="Mensaje"
						placeholder="¿Qué necesita transportar?"
						v-model="datos.mensaje"
						:rules="rules.required"
						required
						></v-textarea>
					<div>
						<v-menu
							ref="menuDate"
							:close-on-content-click="true"
							v-model="menu"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
							class="mb-5"
							padding-left="100px">
						<v-text-field
							slot="activator"
							v-model="fecha"
							label="Seleccione Fecha"
							color="#1f97b9"
							readonly
							:rules="rules.nameRules">
							<img :src='require("../../assets/static/img/fecha.png")' alt="icono de fecha" style="width: 25px;height:25px;" slot="prepend">
						</v-text-field>
						<v-date-picker
							v-model="fecha"
							:min="today"
							no-title
							scrollable
							prev-icon="fas fa-chevron-left caption"
							next-icon="fas fa-chevron-right caption"
							locale="es-mx"
							first-day-of-week="1"
							style="min-height: 400px;"
						>
							<v-spacer></v-spacer>
							<v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
						</v-date-picker>
					</v-menu>

					<!-- <div class="v-input__prepend-outer">
						<img :src='require("../../assets/static/img/hora.png")' style="width: 25px;height:25px;">
					</div> -->
					<div class="hour-picker-container" xs12 md4 px-2>
						<img :src='require("../../assets/static/img/hora.png")' alt="icono de hora" style="width: 25px;height:25px;">
						<v-select
							v-model="hora"
							:items="horas"
							:rules="rules.nameRules"
							append-icon="fas fa-caret-down"
							label="Seleccione Hora"
						></v-select>
					</div>
					</div>
						<!-- Subida de imagenes -->
						<v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
							<!-- <v-text-field label="Seleccione Imagenes" @click='pickFile' v-model="preImagenes.length"></v-text-field> -->
							<p class="mt-3 mb-0">Por favor selecciona las imágenes que desees adjuntar</p>
							<v-btn color="#1f97b9" dark large @click="pickFile">
								Seleccionar Imágenes
							</v-btn>
							<input
								type="file"
								style="display: none"
								ref="image"
								accept="image/*"
								multiple
								:limit= "5"
								@change="onFilePicked"
							>
							<div v-if="preImagenes.length > 0">
								<v-card flat tile class="d-flex">
									<v-img
										v-for="(image, index) in preImagenes"
										:key="index"
										:src="image"
										max-height = "200px"
										max-width = "200px"
										class="grey lighten-2"
										>
									</v-img>
								</v-card>
								<v-btn color="#1f97b9" dark large @click="eraseImages">Eliminar Imágenes</v-btn>
							</div>
						</v-flex>
						<v-flex v-if="usuario && usuario.tipoCliente === 'Convenio' && usuario.activoTramos">
							<v-select
								v-model="categoria"
								:items="mantenedores.tramos_categoria"
								:item-text="returnTramoLabel"
								item-value="id"
								label="Categoria Vehiculo"
								append-icon="fas fa-caret-down"
								return-object
								></v-select>
							<div v-if="categoria !== ''">
								<p><b>Precio Servicio: </b> ${{ getPriceCategory() }} </p>
								<p><b>Descuento: </b> ${{ getDiscount() }} </p>
								<p><b>Precio Final: </b>${{ getFinalPrice() }} </p>
							</div>
						</v-flex>
					<div v-if="pedidoEnviado" >
						<v-btn color="#1f97b9" :disabled="datos.direccion_destino.direccion == '' || datos.direccion_origen.direccion == ''" dark large @click="save_flete()">Enviar</v-btn>
					</div>
					<div v-else>
						<p><b> Su pedido ha sido enviado, nos comunicaremos con usted a la brevedad</b></p>
					</div>	
				</v-flex>
			</v-layout>
		</v-flex>
			
			<!-- Datos de contacto -->
			<!-- <v-flex xs12 md6>
				<h2 class="mb-4 mt-5 text-duo font-weight-regular">Datos de contacto</h2>
					<p class="mb-2"><v-icon class="contact-icon" color="#1f97b9" left>fas fa-home</v-icon> <span>Av. Providencia 1208, Oficina 1603, Santiago - Chile</span></p>
					<p class="mb-2"><v-icon class="contact-icon" color="#1f97b9" left>fas fa-mobile-alt</v-icon> <span>+569 6590 9598</span></p>
					<p class="mb-2"><v-icon class="contact-icon" color="#1f97b9" left>far fa-envelope</v-icon> <span>info@duoapp.cl</span></p>
					<div class="text-xs-center"><img :src='require("../../assets/static/img/man.png")' style="width:100%;max-width:350px;cursor:pointer;" v-on:click="$router.push({name: 'mudanza'})"></div>
			</v-flex> -->
		</v-layout>
		<!--<v-layout row wrap class="inner-container" justify-center mx-auto>
			<GmapMap
				:center="{lat: -33.4289729, lng: -70.6233347}"
				:zoom="16"
				style="width: 100%; height: 400px"
			>
				<GmapMarker
					:position="{lat: -33.4289729, lng: -70.6233347}" />
				/>
			</GmapMap>
		</v-layout> -->    
		<v-snackbar
			v-model="messageContact.show"
			:color="messageContact.type"
			right
			:timeout="4000"
			top>
			{{ messageContact.text }}
			<v-btn
				color="white"
				flat
				@click="messageContact.show = false">
				Ok
			</v-btn>
		</v-snackbar>
	</v-container>
</template>
<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import * as distance from 'google-distance-matrix'
import LoadingLogo from '../../helpers/LoadingLogo'
import VueGtag from "vue-gtag"
export default {
	name: 'Contacto',
	title: 'Negocios y Otros',
	components: {
		LoadingLogo
	},
	data: () => ({
		codigoDefault: '+56',
		codigos: ['+56','+54','+55', '+56','+57','+58','+1','+591','+593','+595','+598'],
		tipoCliente: '',
		hora: '',
		horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
		pedidoEnviado: true,
		loadingPedido: false,
		fleteID: '',
		mantenedores:{},
		menuDate: false,
		today: new Date().toISOString().substr(0, 10),
		theLatLngs: [],
		title: "Image Upload",
		dialog: false,
		imageName: '',
		imageUrl: '',
		imageFile: '',
		valid: false,
		preImagenes: [],
		time: '',
		date:'',
		usuario: null,
		datos:{
			personales: {
				nombre: '',
				apellido:'',
				telefono: '',
				email: '',
				nombreCompleto: ''		
				},
			date: '',
			time: '',
			direccion_origen:{
				direccion: "",
				marker: {},
				direccion_obj: {},
				estacionamiento: ''
				},
			direccion_destino:{
				direccion: "",
				marker: {},
				direccion_obj: {},
				estacionamiento: ''
				},
			paradas: [
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				}
			],
			mensaje: '',
			imagenes: [],
			distancia: {
				duration: {
					value: 0
				}
			}
		},
		messageContact: {
			show: false,
			type: '',
			text: ''
		},
		documento_tributario: {},
		fecha: '',
		menu: undefined,
		rules: {
			required: [ v => !!v || 'Campo obligatorio' ],
			emailRules: [
				v => !!v || 'Campo obligatorio',
				v => {
					const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					if(re.test(v)){
						return true
					}
					return 'Verifica que el email sea válido'
				}
			],
		},
		categoria: '',
		precioConvenio: 0,
		stops: 0,
		paradas: [],
		optimized: false,
		checked: false,
		distanciaMetrica: 0,
		showDistance: false,
		backUpWaypts: [],
		responseGoogle: {},
		optimizedRoute: false
	}),
	methods:{
		gtag_report_conversion(url) {
			var callback = function () {
				if (typeof(url) != 'undefined') {
					window.location = url;
				}
			}
			console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++' + callback)
			gtag('event', 'conversion', {
				'send_to': 'AW-867600071/ffSUCK3Fn_kCEMeN2p0D',
				'event_callback': callback
			})
			return false;
		},
		changeOptimization() {
			const here = this
			this.optimized === true ? this.optimized = false : this.optimized = true
			this.optimizedRoute === true ? this.optimizedRoute = false : this.optimizedRoute = true
			if (!here.optimized && here.stops >= 0 && here.backUpWaypts.length > 0) {
				console.log('aqui debe entrar al no optimizar')
				here.datos.paradas = here.backUpWaypts
				here.backUpWaypts = []
				this.getRoute()
			} else if(this.datos.direccion_origen.direccion != '' && this.datos.direccion_destino.direccion != '') {
				this.getRoute()
			}
			
			
		},
		addStop() {
			if (this.stops < 9) {
				this.stops++
			}
			if (this.stops > 8) {
				this.stops = 8
			}
		},
		eraseStop() {
			const here = this
			// añadir el borrado por parada
			switch (this.stops) {
				case 1:
					here.datos.paradas[0] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 2:
					here.datos.paradas[1] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 3:
					here.datos.paradas[2] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 4:
					here.datos.paradas[3] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 5:
					here.datos.paradas[4] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 6:
					here.datos.paradas[5] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 7:
					here.datos.paradas[6] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				case 8:
					here.datos.paradas[7] =
						{
							direccion: "",
							marker: {},
							direccion_obj: {},
							estacionamiento: ''
						}
					break;
				default:
					break;
			}
			this.getRoute()
			this.stops--
		},
		toThousandFilter(num) {
			return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'))
		},
		getFinalPrice() {
			const here = this
			let precioFinal = 0
			this.mantenedores.tramos_categoria.forEach(function(tramos) {
				if (tramos.id === here.categoria.id) {
					precioFinal = tramos.convenio_values.precio
				}
			})
			if (this.usuario.descuento && this.usuario.tipoCliente === 'Convenio') {
				let sobreDescuento = 0
				if (this.usuario.descuentoEspecial) {
					this.usuario.descuentoEspecial.forEach(function(doc) {
						if (doc.category === here.categoria.id) {
							sobreDescuento = doc.descuento
						}
					})
				}
				here.precioConvenio = ((100 - (here.usuario.descuento + sobreDescuento) )/ 100) * precioFinal
				precioFinal = this.toThousandFilter(((100 - (here.usuario.descuento + sobreDescuento) )/ 100) * precioFinal)
				return precioFinal
			} else {
				here.precioConvenio = precioFinal
				return precioFinal
			}
		},
		getDiscount() {
			const here = this
			let descuento = 0
			if (this.usuario.descuento && this.usuario.tipoCliente === 'Convenio') {
				let sobreDescuento = 0
				let precio = 0
				if (this.usuario.descuentoEspecial) {
					this.usuario.descuentoEspecial.forEach(function(doc) {
						if (doc.category === here.categoria.id) {
							sobreDescuento = doc.descuento
						}
					})
				}
				this.mantenedores.tramos_categoria.forEach(function(tramos) {
					if (tramos.id === here.categoria.id) {
						precio = tramos.convenio_values.precio
						descuento = here.toThousandFilter(Math.round(((here.usuario.descuento + sobreDescuento) / 100) * precio))
					}
				})
			}

			return descuento
		},
		getPriceCategory() {
			const here = this
			let precio = 0
			this.mantenedores.tramos_categoria.forEach(function(tramos) {
			if (tramos.id === here.categoria.id) {
				console.log(tramos)
				precio = here.toThousandFilter(tramos.convenio_values.precio)
			}
			})
			console.log(precio)
			return precio
		},
		returnTramoLabel(item){
			const index = this.mantenedores.tramos_categoria.findIndex(function(element){
				return element.category == item.category
			})
			let label = ''
			if(index !== this.mantenedores.tramos_categoria.length){
				label = this.mantenedores.tramos_categoria[index].category
			}
			return label
		},
		eraseImages(){
			this.preImagenes = []
		},
		getRoute(){
			console.log('entra una vez')
			const here = this
			here.showDistance = false
			this.$gmapApiPromiseLazy().then(async () => {
				this.directionsService = new google.maps.DirectionsService()
				this.directionsDisplay = new google.maps.DirectionsRenderer()
				const waypts = []
				if (this.stops > 0) {
					await this.datos.paradas.forEach(function(parada) {
						if (parada.direccion !== '') {
							const data = {
								location: parada.direccion,
								stopover: true
							}
							waypts.push(data)
						}
					})
				}
				var vm = this
				vm.directionsService.route({
					origin: this.datos.direccion_origen.direccion,
					destination: this.datos.direccion_destino.direccion,
					waypoints: waypts,
					optimizeWaypoints: this.optimized,
					travelMode: 'DRIVING'
				}, function (response, status) {
					vm.theLatLngs = []
					vm.$refs.mapDirections.fitBounds(response.routes[0].bounds)
					response.routes[0].overview_path.map(function(point){ 
						vm.theLatLngs.push({lat: point.lat(), lng: point.lng()})
					})
					let distanciaTotal = 0
					response.routes[0].legs.forEach(function(legs) {
						distanciaTotal += legs.distance.value
					})
					here.distanciaMetrica = parseFloat(distanciaTotal / 1000).toFixed(2)
					here.datos.distancia.duration.value = distanciaTotal
					here.showDistance = true
					// console.log(response)
					if (status === 'OK') {
						vm.directionsDisplay.setDirections(response)
						here.responseGoogle = response
					}
				})
				
			})
			setTimeout(function() {
				if (here.responseGoogle.status === 'OK' && here.optimized) {
					console.log('Esta llena la respuesta de google')
					here.checkBeforeOrder(here.responseGoogle.routes[0].waypoint_order)
				} else {
					console.log('no response')
				}
			}, 500);
		},
		async checkBeforeOrder(order) {
			const here = this
			if (here.optimized && here.stops >= 2) {
				here.backUpWaypts = here.datos.paradas
				const returnedArray = await here.changeOrderPromise(order, here.backUpWaypts)
				console.log(returnedArray)
				here.datos.paradas = returnedArray
			} else {
				here.backUpWaypts = []
			}
		},
		changeOrderPromise(orden, array) {
			return new Promise((resolve, reject) => {
				const here = this
				let index = 0
				const arrayProvisorio = []
				console.log('orden')
				console.log(orden)
				/* orden.forEach(function(c) {
					setTimeout(function() {
						arrayProvisorio[index] = array[c]
						index++
					}, 600);
				}) */
				for (let index = 0; index < orden.length; index++) {
					arrayProvisorio.push(array[orden[index]])
				}
				if (arrayProvisorio.length < 8) {
					const largoRestante = 8 - arrayProvisorio.length
					console.log(largoRestante)
					const data = {
						direccion: "",
						marker: {},
						direccion_obj: {},
						estacionamiento: ''
					}
					for (let index = 0; index < largoRestante; index++) {
						arrayProvisorio.push(data)	
					}
				}
				resolve(arrayProvisorio)
			})
		},
		uploadFile(file, route) {
			console.log('paso1')
			return new Promise((resolve, reject) => {
				console.log('paso2')
				const here = this
				var storageRef = firebase.storage().ref().child(route)
				storageRef.put(file)
				.then(function(snapshot) {
					storageRef.getDownloadURL()
					.then(function(url) {
						resolve(url)
					}).catch(function() {
						here.$message.error('Hubo un error al subir el archivo, por favor intentalo nuevamente.')
						reject('rejected')
					})
				})
				.catch(function() {
					here.$message.error('Hubo un error al subir el archivo, por favor intentalo nuevamente.')
					reject('rejected')
				})
			})
		},
		pickFile() {
			this.$refs.image.click()
			
		},
		onFilePicked(e) {
			const files = e.target.files
			//console.log(files)
			if (files[0] !== undefined) {
				this.imageName = files[0].name
				if (this.imageName.lastIndexOf('.') <= 0) {
					return
					}
				if (files.size > 5000000 || files.length > 5) {
					this.messageContact.text = 'Imagenes menor a 5mb y maximo 5 archivos'
					this.preImagenes = []
				} else {
					for (let index = 0; index < files.length; index++) {
						const fr = new FileReader()
						fr.readAsDataURL(files[index])
						fr.addEventListener('load', async () => {
							this.imageUrl = fr.result
							this.imageFile = files[index] // this is an image file that can be sent to server...
							const route = 'fletes_dev/contacto/' + new Date().getTime() + this.imageFile.name
							const upload = await this.uploadFile(this.imageFile, route)
							this.preImagenes.push(upload)
						})
						
					}
				}
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
		},
		
		setInitialHour(){
				/* eslint-disable */
			this.date = new Date().toISOString().substr(0, 10)
			
			const date = this.$moment().add(this.mantenedores.tiempo_minimo/3600,'h').add(5,'m')
			let horas = date.hour()
			let minutos = date.minute()
			if(minutos == 0 || minutos == 15 || minutos == 30 || minutos == 45 ){}
			else if(minutos < 15){ minutos = 15 }
			else if(minutos < 30){ minutos = 30 }
			else if(minutos < 45){ minutos = 45 }
			else if(minutos < 60){
				if(minutos > 45){
					minutos = 0
					horas++
					if(horas == 24){horas = 0}
				}
			}
			let h = horas.toString()
			let m = minutos.toString()
			if(horas < 10){ h = '0' + horas.toString() }
			if(minutos < 10){ m = '0' + minutos.toString() }
			
			this.time = h + ':' + m
		},
		async get_mantenedores(){
			let db = firebase.firestore()
			let self = this
			await db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
					if (doc.exists) {
							self.mantenedores = doc.data()
							self.setInitialHour()
							const datos = {
								category: 'Por Definir',
								id: 'porDefinir'
							}
							self.mantenedores.tramos_categoria.push(datos)
					} else {
							// doc.data() will be undefined in this case
							console.log("No such document!");
					}
			}).catch(function(error) {
					console.log("Error getting document:", error);
			});

		},
		getDistanceMatrix(waypts){
			 return new Promise(async (resolve, reject) => {
				const here = this
				var service = new google.maps.DistanceMatrixService()
				const arrayDestination = []
				if (waypts.length > 0) {
					// crear un array con todas las direcciones en orden
					let distanciaTotal = 0
					const arrayorganized = [here.datos.direccion_origen.direccion]
					waypts.forEach(function(direccion) {
						arrayorganized.push(direccion.location)
					})
					arrayorganized.push(here.datos.direccion_destino.direccion)
					for (let index = 0; index < arrayorganized.length; index++) {
						const origin = [arrayorganized[index]]
						const destination = [arrayorganized[index + 1]]
						if (index + 1 >= arrayorganized.length) {
							resolve(true)
						} else {
							await service.getDistanceMatrix({
								origins: origin,
								destinations: destination,
								travelMode: 'DRIVING'
							},
							function (response, status) {
									console.log(response)
									distanciaTotal += response.rows[0].elements[0].distance.value
								}
							)
							here.distanciaMetrica = parseFloat(distanciaTotal / 1000).toFixed(2)
							here.datos.distancia.duration.value = distanciaTotal
							here.showDistance = true
						}
						
					}
				} else {
					await service.getDistanceMatrix({
						origins: [this.datos.direccion_origen.direccion],
						destinations: [this.datos.direccion_destino.direccion],
						travelMode: 'DRIVING'
					},
					function (response, status) {
							here.distanciaMetrica = parseFloat(response.rows[0].elements[0].distance.value / 1000).toFixed(2)
							here.datos.distancia.duration.value = response.rows[0].elements[0].distance.value
							here.showDistance = true
							resolve(true)
						}
					)
				}
			})
		},
		save_flete () {
			this.gtag_report_conversion()
			this.datos.personales.nombreCompleto = this.datos.personales.nombre + ' ' + this.datos.personales.apellido 
			console.log(this.nombreCompleto)
			const here = this
			this.loadingPedido = true
			let idCliente = this.$store.state.idCliente
			if (this.$refs.contactForm.validate()) {
				if (here.datos.direccion_destino.direccion !== '' && here.datos.direccion_origen.direccion !== '') {
					const flete = {
						fromPreCotizacion: true,
						basicoValue: {},
						cargos: [],
						completoValue: {},
						created: firebase.firestore.FieldValue.serverTimestamp(),
						datoPagos: [],
						datosDireccion: {
							destino: {
								mover: '',
								numero: 0,
								piso:0,
								tipo:''
							},
							origen: {
								mover: '',
								numero: 0,
								piso:0,
								tipo:''
							}
						},
						descuentos: [],
						direcciones: {
							destino: this.datos.direccion_destino.direccion,
							origen: this.datos.direccion_origen.direccion
						},
						distanciaRecorrido: this.distanciaMetrica,
						distancia:{},
						elementos: [],
						estado: 'En espera',
						fecha: this.fecha,
						hora: this.hora,
						oferta: {},
						paymentValue: 0,
						servicio: '',
						tiempos: {
							carga: 0,
							distancia: Math.round(this.datos.distancia.duration.value/60)
						},
						tipo: 'Flete',
						usuario: {
							nombre: this.datos.personales.nombreCompleto,
							telefono: this.codigoDefault + this.datos.personales.telefono,
							email: this.datos.personales.email,
							nombrePila: this.datos.personales.nombre,
							apellido: this.datos.personales.apellido
						},
						mensaje: this.datos.mensaje,
						imagenes: this.preImagenes,
						Fecha_Estimada: this.datos.date,
						registro: [],
						valorBase: 0,
						clienteID: idCliente,
						pedidoConvenio: false,
						fecha_servicio_obj: new Date(this.fecha + 'T' + this.hora),
						registroCambios: [],
						paradas: [],
						distanciaMetrica: this.distanciaMetrica,
						backUpService: false
					}
					this.datos.paradas.forEach(function(parada) {
						if (parada.direccion !== '') {
							flete.paradas.push(parada.direccion)
						}
					})
					this.paradas = flete.paradas
					console.log(flete)
					/* console.log(flete.tiempos.distancia) */
					const dataElemento = {
							alto: 1,
							ancho: 1,
							cat: '',
							descripcion: 'Generico Flete',
							largo: 1,
							metros: 1,
							nombre: 'Convenio',
							peso: 1,
							qty: 1
						}
					if (this.tipoCliente === 'Convenio') {
						dataElemento.descripcion = 'Generico Convenio'
						const dataTransporte = {
								largo: 2,
								m3: 1,
								tipoTransporte: "Abierto"
							}
						flete.pedidoConvenio = true
						flete.dataTransporte = dataTransporte
						flete.documento_tributario = this.documento_tributario
						flete.categoria = this.categoria,
						flete.comision = 0
					}
					flete.elementos.push(dataElemento)
					here.saveData(flete)
				} else {
					here.loadingPedido = false
					here.messageContact.show = true
					here.messageContact.type = 'error'
					here.messageContact.text = 'Debe ingresar direccion de destino y origen.'
				}
			} else {
				here.loadingPedido = false
				here.messageContact.show = true
				here.messageContact.type = 'error'
				here.messageContact.text = 'Debe ingresar toda la informacion de contacto, fecha y hora.'
			}
			
		},
		saveData(flete) {
			const here = this
			let idCliente = this.$store.state.idCliente
			let db = firebase.firestore()
			db.collection("fletes_dev").add(flete)
				.then(function(docRef) {
					console.log(docRef.id)
					let fleteID = docRef.id
					if (idCliente != '') {
						var addMessage = db.collection('users').doc(idCliente)
						addMessage.update({
							fletes: firebase.firestore.FieldValue.arrayUnion(fleteID)
						})
					}
					const data = {
						id: fleteID
					}
					db.collection('fletes_dev').doc(fleteID).update(data)
					/* here.loadingPedido = false */
					// this.fleteID = docRef.id
					//console.log(this.fleteID)
					if (here.tipoCliente !== 'Convenio' || here.categoria === 'porDefinir' || !here.usuario.activoTramos) {
						here.sendForm(docRef.id, flete.pedidoConvenio)
					} else if (here.tipoCliente === 'Convenio' && here.categoria !== 'porDefinir') {
						flete.valorBase = here.precioConvenio
						flete.id = fleteID
						here.getVehiculos(here.categoria, flete)
					}
					
				})
		},
		getVehiculos(categoria, flete) {
			const db = firebase.firestore()
			const here = this
			const arrayVehiculos = []
			db.collection('vehiculos').where('datos.cat_tramo', '==', categoria.id).where('active_duo', '==', true).get().then(function(querySnapshot) {
				if (!querySnapshot.empty) {
					querySnapshot.forEach(function(doc) {
						const data = doc.data()
						data.id = doc.id
						arrayVehiculos.push(data.id)
						here.loadingPedido = true
					})
					console.log(arrayVehiculos)
					here.checkAgenda(arrayVehiculos,flete,categoria)
				} else {
					console.log('No hay vehiculos disponibles')
					const data = {
						estado: 'URGENTE',
						aviso: 'No hay vehiculo segun la categoria solicitada por el cliente, precio del servicio: $' + here.toThousandFilter(flete.valorBase) + '. El cliente ha seleccionado la categoria: ' + categoria.category
					}
					db.collection('fletes_dev').doc(flete.id).update(data)
					here.sendForm(flete.id, flete.pedidoConvenio)
				}
			})
		},
		checkAgenda(arrayVehiculos,flete,categoria) {
			const db = firebase.firestore()
			const here = this
			const start = new Date()
			let gotVehicle = false
			let vehicleID = ''
			for (let index = 0; index < arrayVehiculos.length; index++) {
				const asignTruckCategory = firebase.functions().httpsCallable('asignTruckCategory')
				const data = {
					duracion: categoria.convenio_values.duracion_horas * 60,
					idVehiculo: arrayVehiculos[index],
					fecha: flete.fecha,
					hora: flete.hora,
					documento: 'fletes_dev',
					id: flete.id
				}
				console.log(data)
				asignTruckCategory(data).then(({ data }) => {
					console.log(data)
					if (data) {
						gotVehicle = true
						vehicleID = arrayVehiculos[index]
						index = arrayVehiculos.length
						console.log('Si encontró vehiculo')
					}
					if (index === arrayVehiculos.length && gotVehicle) {
						//agendar vehiculo
						console.log('Encontró y cerró ciclo')
						here.asignarVehiculo(vehicleID, categoria, flete)
					} else if (index === arrayVehiculos.length) {
						const data = {
							estado: 'URGENTE',
							aviso: 'No hay vehiculo segun la categoria solicitada por el cliente, precio del servicio: $' + here.toThousandFilter(flete.valorBase) + '. El cliente ha seleccionado la categoria: ' + categoria.category
						}
						db.collection('fletes_dev').doc(flete.id).update(data)
						here.sendForm(flete.id, flete.pedidoConvenio)
					}
				})
			}
		},
		async asignarVehiculo(idVehiculo, categoria, flete) {
			const here = this
			const db = firebase.firestore()
			let vehiculo
			let conductor
			let transportista
			await db.collection('vehiculos').doc(idVehiculo)
				.get()
				.then(function(doc) {
				if (doc.exists) {
					vehiculo = doc.data()
					vehiculo.id = doc.id
				}
				})
			if (vehiculo) {
				const idConductor = vehiculo.conductor
				const idTransportista = vehiculo.transportista
				await db.collection('conductores').doc(idConductor)
                  .get()
                  .then(function(doc) {
                    if (doc.exists) {
                      conductor = doc.data()
                      conductor.id = doc.id
                    }
                  })
				await db.collection('transportistas').doc(idTransportista)
					.get()
					.then(function(doc) {
						if (doc.exists) {
							transportista = doc.data()
							transportista.id = doc.id
						}
					})
			}
			console.log(vehiculo)
			console.log(conductor)
			console.log(transportista)
			const data = {
				transportista: {
					active_duo: true,
					archivos: vehiculo.archivos,
					conductor: vehiculo.conductor,
					conductor_data: conductor,
					created: firebase.firestore.FieldValue.serverTimestamp(),
					datos: vehiculo.datos,
					disponible: false,
					id: vehiculo.id,
					transportista: transportista.id
				},
				estado: 'Registrado'
			}
			console.log(data)
			db.collection('fletes_dev').doc(flete.id).update(data)
			flete.transportista = data.transportista
			here.ingresarAgenda(idVehiculo, categoria, flete, conductor)
		},
		async ingresarAgenda(idVehiculo, categoria, flete, conductor) {
          console.log('entra ingresaragenda')
            const here = this
            let tiempo = categoria.convenio_values.duracion_horas * 60
            const data = {
              start: this.$moment(flete.fecha + ' ' + flete.hora).format(),
              end: this.$moment(flete.fecha + ' ' + flete.hora).add(tiempo, 'm').format(),
              startobj: this.$moment(flete.fecha + ' ' + flete.hora).toDate(),
              endobj: this.$moment(flete.fecha + ' ' + flete.hora).add(tiempo, 'm').toDate(),
              title: 'Pedido: ' + flete.id,
              idPedido: flete.id,
              origen: flete.direcciones.origen,
              destino: flete.direcciones.destino,
              usuario: flete.usuario.nombre,
              checked: false,
              aceptado: false,
              created: new Date(),
              type: 2,
              onHold: false
            }
            if (flete.pedidoConvenio) {
              data.type = 3
            }
            console.log('ingresarAgenda')
            console.log(data)
            const db = firebase.firestore()
            await db.collection('vehiculos').doc(idVehiculo).collection('agenda').add(data)
              .then(async function(docRef) {
                flete.transportista.agenda = docRef.id
                await db.collection('fletes_dev').doc(flete.id).set(flete, { merge: true })
                if (here.tipoCliente === 'Convenio') {
                  const dataPedido = flete
                  const dataCliente = {
                      tipoCliente: here.usuario.tipoCliente,
                      razonSocial: here.usuario.razonSocial
                  }
                  dataPedido.pedidoAutoAgendado = true
                  /* if (flete.estado === 'Registrado') {
                    dataPedido.holdRespuesta = fasle
                    dataPedido.justTransportChange = false
                  } */
                  dataPedido.cliente = dataCliente
                  dataPedido.emailTransporte = conductor.datos.email
                  dataPedido.conductor = conductor.datos.nombres + ' ' + conductor.datos.apellidos
                  dataPedido.precioNeto = flete.valorBase / 1.19
                  dataPedido.comision = categoria.convenio_values.comision
                  dataPedido.condiciones = 'Pedido Convenio'
                  dataPedido.id = flete.id
                  dataPedido.type = 'f'
                  dataPedido.trp = flete.transportista.id
                  dataPedido.comisionTransportista = '$' + here.toThousandFilter(Math.round(dataPedido.precioNeto * ((100 - categoria.convenio_values.comision)/ 100)))
                  dataPedido.fechaServicio = here.$moment(dataPedido.fecha + 'T' + dataPedido.hora).format('dddd, DD/MM/YY')
                  console.log(dataPedido)
                  const cargoLC = firebase.functions().httpsCallable('cargoCuentaCorriente')
                  await cargoLC(dataPedido)
                    .then(({ data }) => {
                      console.log('Transaccion', data)
                      console.log('Antes del descuento')
					  here.cargoCuentaCorriente(flete.valorBase)
                    })
                    .catch(httpsError => {
                      console.log('error: ', httpsError)
                    })
                }
              })
              .catch(function(error) {
                console.log(error)
              })
        },
		async cargoCuentaCorriente(valor) {
			const here = this
			const db = firebase.firestore()
			const data = {
				cuentaCorriente: {
					montoMaximo: here.usuario.cuentaCorriente.montoMaximo,
					usado: here.usuario.cuentaCorriente.usado + valor
				}
			}
			await db.collection('users').doc(here.usuario.id).update(data).then(function() {
				here.loadingPedido = false
				here.pedidoEnviado = false
				here.messageContact.show = true
				here.messageContact.type = 'success'
				here.messageContact.text = 'Se ha enviado correctamente el mensaje, nos pondremos en contacto contigo a la brevedad.'
			})
		},
		sendForm(id, pedidoConvenio){
			console.log(id)
			const here = this
			if(this.$refs.contactForm.validate()){
				const contactFormEmail = firebase.functions().httpsCallable('contactFormEmail')
				contactFormEmail({
					nombre: this.datos.personales.nombreCompleto,
					email: this.datos.personales.email,
					telefono: this.datos.personales.telefono,
					origen: this.datos.direccion_origen.direccion,
					destino: this.datos.direccion_destino.direccion,
					observaciones: this.datos.mensaje,
					imagenes: this.preImagenes,
					fecha: this.fecha + ' ' + this.hora,
					fleteID: id,
					pedidoConvenio: pedidoConvenio,
					hora: this.hora,
					paradas: this.paradas
				})
				.then(({data}) => {
					// this.getDistanceMatrix() //va a hacer el calculo de distancia necesario para el la funcion asigntruck de functions. luego de ello da el paso al save_flete()
					console.log('data de respuesta')
					console.log(data)
					this.pedidoEnviado = false
					this.loadingPedido = false
					this.messageContact.show = true
					this.messageContact.type = 'success'
					this.messageContact.text = 'Se ha enviado correctamente el mensaje, nos pondremos en contacto contigo a la brevedad.'
				})
				.catch(httpsError => {
					this.loadingPedido = false
					console.log(httpsError)
					this.messageContact.show = true
					this.messageContact.type = 'error'
					this.messageContact.text = 'Hubo un error al enviar el formulario, por favor intenta nuevamente.'
				})
			}
			
		},
		resetContactForm(){
			this.datos={
				personales: {
					nombre: '',
					telefono: '',
					email: ''
					},
				date: '',
				time: '',
				direccion_origen:{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
					},
				direccion_destino:{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
					},
				mensaje: '',
				imagenes: [],
				paradas: [
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				},
				{
					direccion: "",
					marker: {},
					direccion_obj: {},
					estacionamiento: ''
				}
			]
			}
			this.preImagenes = []
		}
	},
	mounted (){
		const idCliente = this.$store.state.idCliente
		console.log(idCliente)
		const here = this
		if (idCliente != '') {
			const db = firebase.firestore()
			db.collection('users').doc(idCliente).get().then(function(doc) {
				here.usuario = doc.data()
				here.usuario.id = doc.id
				const arrayApellido = here.usuario.nombre.split([' '], [2])
				const nombre = arrayApellido[0]
				let apellido = ''
				if (arrayApellido[1] !== undefined) {
					apellido = arrayApellido[1]
				}
				here.datos.personales.nombre = nombre
				here.datos.personales.apellido = apellido
				here.datos.personales.telefono= here.usuario.telefono
				here.datos.personales.email= here.usuario.email
				here.tipoCliente = here.usuario.tipoCliente
				here.documento_tributario.documento = 'Factura'
				here.documento_tributario.boleta = {
					nombre: here.usuario.nombre,
					rut: here.usuario.rut
				}
				here.documento_tributario.factura = {
					ciudad: here.usuario.ciudad,
					comuna: here.usuario.comuna,
					direccion: here.usuario.direccion,
					giroComercial: here.usuario.giroComercial,
					razonSocial: here.usuario.razonSocial,
					rut: here.usuario.rut,
					telefono: here.usuario.telefono
				}
			})

		}
		this.$gmapApiPromiseLazy().then(() => {
				let self = this
				let options = {
					componentRestrictions: {country: "cl"}
				}

				//Origen
				let starting_address_input = document.getElementById('starting_address')
				let starting_address_autocomplete = new google.maps.places.Autocomplete(starting_address_input, options)
				starting_address_autocomplete.addListener('place_changed', function() {
					let place = starting_address_autocomplete.getPlace();

					self.datos.direccion_origen.direccion_obj = place
					self.datos.direccion_origen.marker = place.geometry.location
					self.datos.direccion_origen.direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != ''){
						self.getRoute()
					}
				})

				//paradas


				let stop_address_input = document.getElementById('location_address')
				let stop_address_autocomplete = new google.maps.places.Autocomplete(stop_address_input, options)
				stop_address_autocomplete.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete.getPlace();
					self.datos.paradas[0].direccion_obj = place
					self.datos.paradas[0].marker = place.geometry.location
					self.datos.paradas[0].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input2 = document.getElementById('location_address_2')
				let stop_address_autocomplete2 = new google.maps.places.Autocomplete(stop_address_input2, options)
				stop_address_autocomplete2.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete2.getPlace();
					self.datos.paradas[1].direccion_obj = place
					self.datos.paradas[1].marker = place.geometry.location
					self.datos.paradas[1].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input3 = document.getElementById('location_address_3')
				let stop_address_autocomplete3 = new google.maps.places.Autocomplete(stop_address_input3, options)
				stop_address_autocomplete3.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete3.getPlace();
					self.datos.paradas[2].direccion_obj = place
					self.datos.paradas[2].marker = place.geometry.location
					self.datos.paradas[2].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input4 = document.getElementById('location_address_4')
				let stop_address_autocomplete4 = new google.maps.places.Autocomplete(stop_address_input4, options)
				stop_address_autocomplete4.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete4.getPlace();
					self.datos.paradas[3].direccion_obj = place
					self.datos.paradas[3].marker = place.geometry.location
					self.datos.paradas[3].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input5 = document.getElementById('location_address_5')
				let stop_address_autocomplete5 = new google.maps.places.Autocomplete(stop_address_input5, options)
				stop_address_autocomplete5.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete5.getPlace();
					self.datos.paradas[4].direccion_obj = place
					self.datos.paradas[4].marker = place.geometry.location
					self.datos.paradas[4].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input6 = document.getElementById('location_address_6')
				let stop_address_autocomplete6 = new google.maps.places.Autocomplete(stop_address_input6, options)
				stop_address_autocomplete6.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete6.getPlace();
					self.datos.paradas[5].direccion_obj = place
					self.datos.paradas[5].marker = place.geometry.location
					self.datos.paradas[5].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input7 = document.getElementById('location_address_7')
				let stop_address_autocomplete7 = new google.maps.places.Autocomplete(stop_address_input7, options)
				stop_address_autocomplete7.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete7.getPlace();
					self.datos.paradas[6].direccion_obj = place
					self.datos.paradas[6].marker = place.geometry.location
					self.datos.paradas[6].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				let stop_address_input8 = document.getElementById('location_address_8')
				let stop_address_autocomplete8 = new google.maps.places.Autocomplete(stop_address_input8, options)
				stop_address_autocomplete8.addListener('place_changed', function() {
					console.log('cambia la direccion')
					let place = stop_address_autocomplete8.getPlace();
					self.datos.paradas[7].direccion_obj = place
					self.datos.paradas[7].marker = place.geometry.location
					self.datos.paradas[7].direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != '' && !self.optimizedRoute){
						self.getRoute()
					}
				})
				//Destino
				let destination_address_input = document.getElementById('destination_address')
				let destination_address_autocomplete = new google.maps.places.Autocomplete(destination_address_input, options)
				destination_address_autocomplete.addListener('place_changed', function() {
					let place = destination_address_autocomplete.getPlace();

					//console.log(place)
					self.datos.direccion_destino.direccion_obj = place
					self.datos.direccion_destino.marker = place.geometry.location
					self.datos.direccion_destino.direccion = place.formatted_address
					if(self.datos.direccion_origen.direccion != '' && self.datos.direccion_destino.direccion != ''){
						self.getRoute()
					}

				})
				
			})
		this.get_mantenedores()
	}
	}
</script>